(() => {
  // app/scripts/quickview-component.js
  var customElementsName = "component-quickview";
  !window.customElements.get(customElementsName) && window.customElements.define(
    customElementsName,
    class extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.init();
      }
      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }
      init() {
        this.btn = this.querySelector("button");
        this.btn.addEventListener("click", (event) => {
          event.preventDefault();
          this.fetchUrl();
        });
      }
      resizeHandler() {
        const popup = document.querySelector("#popupQuickview");
        const element = popup.querySelector(".js-main-image-wrapper .swiper");
        this.resizeObserver = new ResizeObserver((entries) => {
          if (window.matchMedia("(max-width: 749px)").matches) return;
          for (let entry of entries) {
            this.calculateThumbHeight();
          }
        });
        this.resizeObserver.observe(element);
      }
      async fetchUrl() {
        const { url } = this.dataset;
        const new_url = url.split("?")[0] + "?view=quick-view";
        this.loading = true;
        if (!window.jsPDPFileLoaded || !document.querySelector('script[src*="/assets/product-page.js"]')) {
          const script = document.createElement("script");
          script.src = window.theme.assets.productPage;
          document.head.insertAdjacentElement("beforeend", script);
          window.jsPDPFileLoaded = true;
        }
        const popup = document.querySelector("#popupQuickview");
        let result = await fetch(new_url);
        result = await result.text();
        const div = document.createElement("div");
        div.innerHTML = result;
        popup.querySelector(".popup-body").innerHTML = div.querySelector(".product-container").innerHTML;
        popup.querySelectorAll("script[src]").forEach((oldScriptTag) => {
          const newScriptTag = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
        this.calculateThumbHeight();
        this.resizeHandler();
        if (typeof window.affirm?.ui?.refresh === "function") {
          window.affirm.ui.refresh();
        }
        requestAnimationFrame(() => {
          popup.open();
          this.loading = false;
        });
      }
      calculateThumbHeight() {
        const popup = document.querySelector("#popupQuickview");
        const mainSlider = popup.querySelector(".js-main-image-wrapper .swiper");
        const mainSliderHeight = mainSlider.getBoundingClientRect().height;
        popup.style.setProperty("--main-slider-height", mainSliderHeight + "px");
      }
      set loading(bool) {
        const button = this.btn;
        if (bool) {
          button.setAttribute("aria-busy", true);
          button.classList.add("disabled");
          button.HTMLTemp = button.innerHTML;
          button.innerHTML = document.querySelector("#svg_loading").innerHTML;
        } else {
          button.removeAttribute("aria-busy");
          button.classList.remove("disabled");
          button.innerHTML = button.HTMLTemp;
          button.HTMLTemp = null;
        }
        document.getElementById("popupQuickview").classList.toggle("loading", bool);
      }
    }
  );
  var QVThumbSliderComponent = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const config = this.querySelector('script[type*="json"]');
      if (!config) return;
      this.config = JSON.parse(config.innerHTML);
      this.config.spaceBetween && (this.config.spaceBetween = +this.config.spaceBetween.toString().replace(/[^\d.,]/g, ""));
      this.config.freeMode = {
        enabled: true,
        sticky: true
      };
      for (let i in this.config.breakpoints) {
        let spaceBetween = this.config.breakpoints[i]?.spaceBetween || 0;
        this.config.breakpoints[i].spaceBetween = +spaceBetween.toString().replace(/[^\d.,]/g, "");
      }
      if (this.hasAttribute("slide-wait")) return;
    }
    createSlide() {
      const { Swiper, Modules } = window.SwiperSlider;
      if (!this.slider) {
        this.slider = new Swiper(this, {
          init: false,
          ...this.config,
          modules: Modules
        });
        this.slider.on("init", this.onInit.bind(this));
        this.slider.on("slideChange", this.onSlideChange.bind(this));
        this.slider.init();
        return this.slider;
      }
    }
    onSlideChange(swiper) {
    }
    onInit() {
    }
  };
  !window.customElements.get("product-qv-thumbnail-slider-component") && window.customElements.define("product-qv-thumbnail-slider-component", QVThumbSliderComponent);
  var QVSliderComponent = class extends QVThumbSliderComponent {
    constructor() {
      super();
    }
    connectedCallback() {
      super.connectedCallback();
      if (window.SwiperSlider) {
        this.initSwiper();
      } else {
        document.addEventListener("SwiperSliderLoaded", () => {
          this.initSwiper();
        });
      }
    }
    initSwiper() {
      const thumbSliderElement = document.querySelector("product-qv-thumbnail-slider-component");
      if (thumbSliderElement) {
        window.customElements.whenDefined("product-qv-thumbnail-slider-component").then(() => {
          const thumbsSwiper = thumbSliderElement.createSlide();
          if (thumbsSwiper) {
            this.config.thumbs = {
              swiper: thumbsSwiper
            };
          }
          this.createSlide();
        });
      }
    }
  };
  !window.customElements.get("product-qv-slider-component") && window.customElements.define("product-qv-slider-component", QVSliderComponent);
  var QuickViewPopup = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.addEventListener("click", (e) => {
        const { target } = e;
        if (target.closest("#configureQuickView")) {
          e.preventDefault();
          e.stopPropagation();
          const productForm = target.closest("product-form-quick-view") || target.closest("[data-url]");
          const productUrl = productForm.getAttribute("data-url");
          const newUrl = `${productUrl}?launch_designer=true`;
          window.location.href = newUrl;
        }
      });
      this.startY = 0;
      this.currentY = 0;
      this.threshold = 80;
      this.handleTouchMove = this.handleTouchMove.bind(this);
      this.handleTouchEnd = this.handleTouchEnd.bind(this);
      this.handleMouseMove = this.handleMouseMove.bind(this);
      this.handleMouseUp = this.handleMouseUp.bind(this);
      this.closest("popup-component").addEventListener("popup:afterClose", (e) => {
        this.removeEventListener("mousemove", this.handleMouseMove, { passive: false });
        this.removeEventListener("touchmove", this.handleTouchMove, { passive: false });
      });
      const mobileCloseBar = this.querySelector(".mobile-close-bar");
      mobileCloseBar.addEventListener("touchstart", (event) => {
        event.preventDefault();
        this.startY = event.touches[0].clientY;
        this.addEventListener("touchmove", this.handleTouchMove, { passive: false });
      }, { passive: false });
      mobileCloseBar.addEventListener("touchend", this.handleTouchEnd);
      mobileCloseBar.addEventListener("mousedown", (event) => {
        event.preventDefault();
        this.startY = event.clientY;
        this.addEventListener("mousemove", this.handleMouseMove, { passive: false });
      });
      mobileCloseBar.addEventListener("mouseup", this.handleMouseUp);
    }
    handleMouseMove(event) {
      this.currentY = event.clientY;
      const deltaY = this.currentY - this.startY;
      if (deltaY > 0) {
        this.style.setProperty("transition", "none");
        this.style.setProperty("transform", `translateY(${deltaY}px)`, "important");
        if (deltaY > this.threshold) {
          this.style.removeProperty("transition");
          this.querySelector(".btn-popup-close").click();
          requestAnimationFrame(() => {
            this.removeEventListener("mousemove", this.handleMouseMove, { passive: false });
            this.style.removeProperty("transform");
          });
        }
      }
    }
    handleMouseUp(event) {
      this.removeEventListener("mousemove", this.handleMouseMove, { passive: false });
      this.style.removeProperty("transition");
      this.style.removeProperty("transform");
    }
    handleTouchMove(event) {
      this.currentY = event.touches[0].clientY;
      const deltaY = this.currentY - this.startY;
      if (deltaY > 0) {
        this.style.setProperty("transition", "none");
        this.style.setProperty("transform", `translateY(${deltaY}px)`, "important");
        if (deltaY > this.threshold) {
          this.style.removeProperty("transition");
          this.querySelector(".btn-popup-close").click();
          requestAnimationFrame(() => {
            this.removeEventListener("mousemove", this.handleMouseMove, { passive: false });
            this.style.removeProperty("transform");
          });
        }
      }
    }
    handleTouchEnd(event) {
      this.removeEventListener("touchmove", this.handleTouchMove, { passive: false });
      this.style.removeProperty("transform");
      this.style.removeProperty("transition");
    }
  };
  !window.customElements.get("quickview-popup") && window.customElements.define("quickview-popup", QuickViewPopup);
  !window.customElements.get("product-form-quick-view") && customElements.define(
    "product-form-quick-view",
    class extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.scriptElement = this.querySelector('script[type="application/json"].object-product');
        this.JSON = this.scriptElement ? JSON.parse(this.scriptElement.textContent).product : window.theme.product;
        this.linkOptions();
        this.template = this.querySelector("[data-variant-template]")?.content || null;
        this.container = this.closest("popup-component") || this.closest(".shopify-section");
        this.addEventListener("change", this.onChange.bind(this));
      }
      disconnectedCallback() {
      }
      onChange(event) {
        const target = event.target;
        if (!target.classList.contains("js-variant-change")) return;
        let index = +target.name.replace(/[^\d]/g, "");
        if (index == 1) {
          this.updateOptionsInSelector(2);
          this.updateOptionsInSelector(3);
        }
        if (index == 2) {
          this.updateOptionsInSelector(3);
        }
        if (!this.getVariant()) return;
        if (this.currentVariant) {
          this.updateId();
          this.updateAffirm();
          this.updateContent();
        } else {
          this.setUnavailable();
        }
      }
      updateAffirm() {
        const affirmElement = this.querySelector(".affirm-as-low-as");
        if (!affirmElement) return;
        affirmElement.setAttribute("data-amount", this.currentVariant.price);
        window.affirm?.ui?.refresh?.();
      }
      updateId() {
        if (this.currentVariant) {
          const masterID = this.querySelector('[name="id"]');
          if (masterID.tagName == "SELECT") {
            masterID.value = this.currentVariant.id;
            masterID.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }
      }
      getCurrentOptions() {
        let currentOptions = [];
        this.JSON.options.forEach((option, index) => {
          let optionName = `[name="option${index + 1}"]`;
          if (this.querySelector(optionName).tagName == "INPUT") {
            currentOptions.push(this.querySelector(optionName + ":checked")?.value);
          } else {
            currentOptions.push(this.querySelector(optionName)?.value);
          }
        });
        return currentOptions;
      }
      getVariant() {
        const options = this.getCurrentOptions();
        this.currentVariant = this.JSON.variants.find((variant) => {
          return !variant.options.map((option, index) => {
            return options[index] === option;
          }).includes(false);
        });
        if (!this.currentVariant) {
          let selectOptions = Array.from(this.querySelectorAll("select[name*=option], input[name*=option]:checked")).filter((i) => i != null);
          if (this.JSON.options.length != selectOptions.length) return false;
        }
        return true;
      }
      // handleKonfiguratorUpdated({ detail }) {
      //     const { updatedPrice } = detail;
      //     const mainPrice = this.querySelector(".js-main-price");
      //     if (!mainPrice) return;
      //     const konfiguratorPriceAdjustment = updatedPrice - parseInt(mainPrice.dataset.origin);
      //     this.konfiguratorPriceAdjustment = konfiguratorPriceAdjustment;
      //     mainPrice.setAttribute("data-konfigurator-price-adjustment", konfiguratorPriceAdjustment);
      //     this.updatePriceElments();
      // }
      // updatePriceElments() {
      //     const mainPrice = this.querySelector(".js-main-price");
      //     const comparePrice = this.querySelector(".js-compare-price");
      //     if (!mainPrice) return;
      //     const konfiguratorPriceAdjustment =
      //         this.konfiguratorPriceAdjustment ||
      //         (mainPrice.hasAttribute("data-konfigurator-price-adjustment")
      //             ? parseFloat(mainPrice.getAttribute("data-konfigurator-price-adjustment"))
      //             : 0);
      //     const bcpoPriceAdjustment = mainPrice.hasAttribute("data-bcpo-price-adjustment")
      //         ? parseFloat(mainPrice.getAttribute("data-bcpo-price-adjustment"))
      //         : 0;
      //     const totalPriceAdjustment = bcpoPriceAdjustment + konfiguratorPriceAdjustment;
      //     const mainPriceNew = parseFloat(mainPrice.dataset.origin) + totalPriceAdjustment;
      //     mainPrice.set(mainPriceNew);
      //     if (comparePrice) {
      //         const comparePriceNew = parseFloat(comparePrice.dataset.origin) + totalPriceAdjustment;
      //         comparePrice.set(comparePriceNew);
      //     }
      // }
      updateContent() {
        if (!this.template) return;
        const template = this.template.querySelector(`[data-variant-id="${this.currentVariant?.id}"]`);
        Array.from(document.querySelectorAll(".jsVariantUpdate")).forEach((node) => {
          const { updateId } = node.dataset;
          if (!updateId.includes(this.dataset.formId)) return;
          const target = template?.querySelector(`.jsVariantUpdate[data-update-id="${node.dataset.updateId}"]`);
          node.innerHTML = target?.innerHTML || "";
          target && (node.className = target.className);
        });
      }
      setUnavailable() {
        this.querySelectorAll(".add-to-cart")?.forEach((item) => {
          item.innerHTML = theme.string.unavailable;
        });
        this.querySelectorAll('.jsVariantUpdate[data-update-id*="price"]')?.forEach((item) => {
          item.innerHTML = `<span class="price">${theme.string.unavailable}</span>`;
        });
      }
      linkOptions() {
        this.optionsMap = {};
        this.availableOptions = {};
        for (var i = 0; i < this.JSON.variants.length; i++) {
          let variant = this.JSON.variants[i];
          this.optionsMap["root"] = this.optionsMap["root"] || [];
          this.optionsMap["root"].push(variant.option1);
          this.optionsMap["root"] = [...new Set(this.optionsMap["root"])];
          if (this.JSON.options.length > 1) {
            var key = variant.option1;
            this.optionsMap[key] = this.optionsMap[key] || [];
            this.optionsMap[key].push(variant.option2);
            this.optionsMap[key] = [...new Set(this.optionsMap[key])];
          }
          if (this.JSON.options.length === 3) {
            var key = variant.option1 + " / " + variant.option2;
            this.optionsMap[key] = this.optionsMap[key] || [];
            this.optionsMap[key].push(variant.option3);
            this.optionsMap[key] = [...new Set(this.optionsMap[key])];
          }
          if (variant.available) {
            this.availableOptions["root"] = this.availableOptions["root"] || [];
            this.availableOptions["root"].push(variant.option1);
            this.availableOptions["root"] = [...new Set(this.availableOptions["root"])];
            if (this.JSON.options.length > 1) {
              var key = variant.option1;
              this.availableOptions[key] = this.availableOptions[key] || [];
              this.availableOptions[key].push(variant.option2);
              this.availableOptions[key] = [...new Set(this.availableOptions[key])];
            }
            if (this.JSON.options.length === 3) {
              var key = variant.option1 + " / " + variant.option2;
              this.availableOptions[key] = this.availableOptions[key] || [];
              this.availableOptions[key].push(variant.option3);
              this.availableOptions[key] = [...new Set(this.availableOptions[key])];
            }
          }
        }
        if (!Array.from(this.querySelectorAll("select[name*=option], input[name*=option]:checked")).filter((i2) => i2 != null).length) return;
        this.updateOptionsInSelector(1);
        this.JSON.options.length > 1 && this.updateOptionsInSelector(2);
        this.JSON.options.length === 3 && this.updateOptionsInSelector(3);
      }
      updateOptionsInSelector(index) {
        let key;
        let selector;
        const optionEl = {
          option1: Array.from(this.querySelectorAll("select[name=option1], input[name=option1]:checked")).find((i) => i != null),
          option2: Array.from(this.querySelectorAll("select[name=option2], input[name=option2]:checked")).find((i) => i != null),
          option3: Array.from(this.querySelectorAll("select[name=option3], input[name=option3]:checked")).find((i) => i != null)
        };
        switch (index) {
          case 1:
            key = "root";
            selector = optionEl.option1;
            break;
          case 2:
            key = optionEl.option1?.value;
            selector = optionEl.option2;
            break;
          default:
            key = optionEl.option1?.value;
            selector = optionEl.option3;
            key += " / " + optionEl.option2?.value;
            index = 3;
        }
        if (!selector) {
          selector = Array.from(this.querySelectorAll(`select[name=option${index}], input[name=option${index}]`)).find((i) => i != null);
        }
        const availableOptions = this.optionsMap[key] || [];
        const optionsValid = this.availableOptions[key] || [];
        const initialValue = selector?.value || "null";
        if (!selector) return;
        if (selector.tagName == "SELECT") {
          Array.from(selector.querySelectorAll("option")).forEach((option) => {
            availableOptions.includes(option.value) ? option.removeAttribute("hidden") : option.setAttribute("hidden", "");
          });
          if (availableOptions.length && !availableOptions.includes(initialValue)) {
            selector.value = availableOptions[0];
          }
        } else {
          Array.from(this.querySelectorAll(`[name=${selector.name}]`)).forEach((input) => {
            input.classList.toggle("disabled", !optionsValid.includes(input.value));
            input.classList.toggle("unavailable", !availableOptions.includes(input.value));
          });
          if (availableOptions.length && !availableOptions.includes(initialValue)) {
            const tempInput = document.createElement("input");
            tempInput.type = "text";
            tempInput.value = availableOptions[0];
            const findAvailableInput = Array.from(this.querySelectorAll(`[name=${selector.name}]`)).find((input) => input.value == tempInput.value);
            findAvailableInput && (findAvailableInput.checked = true);
          }
        }
      }
    }
  );
})();
